import { Navigate, useParams } from "react-router-dom";
import { getStoredAccountType } from "../auth";
import { CreateAuthorizationRequestPage } from "./CreateAuthorizationRequestPage";

export function EditAuthorizationRequestPage() {
  const { id } = useParams();
  const editId = Number(id);
  const isAdmin = getStoredAccountType() === "admin";

  if (!isAdmin || !Number.isFinite(editId) || editId <= 0) {
    return <Navigate to="/dashboard/requests" replace />;
  }

  return <CreateAuthorizationRequestPage editId={editId} />;
}
